// extracted by mini-css-extract-plugin
export default {"row":"ContentFooter_row__c16r7","placeHolderShimmer":"ContentFooter_placeHolderShimmer__mh3sh"};